import { createSelector } from 'reselect';
import { selectInstitution } from 'redux/configurations/selectors';

const paymentConfigSelector = (state) => state.payment;

export const selectAllConfigs = createSelector(
  [paymentConfigSelector],
  (payment) => payment.allConfigs
);

export const selectAllConfigLoading = createSelector(
  [paymentConfigSelector],
  (payment) => payment.fetchingAllconfigurations
);

// Paystack
export const selectPaystackConfig = createSelector(
  [paymentConfigSelector],
  (payment) => payment.paystack
);

export const selectPaystackConfigSummary = createSelector(
  [selectAllConfigs, selectPaystackConfig],
  (allConfigs, paystackConfig) =>
    allConfigs?.find((config) => config?.id === paystackConfig?.id) || null
);

export const selectPaystackCharge = createSelector(
  [paymentConfigSelector],
  (payment) => payment.paystack?.schoolConfig?.charge || 0
);

export const selectPaystackChargeStatus = createSelector(
  [selectPaystackConfigSummary],
  (summary) => summary?.isChargeEnabled || false
);

export const selectPaystackConfigLoading = createSelector(
  [paymentConfigSelector],
  (payment) => payment.fetchingPaystackConfig
);

// Remita

export const selectRemitaConfig = createSelector(
  [paymentConfigSelector],
  (payment) => payment.remita
);

export const selectRemitaConfigSummary = createSelector(
  [selectAllConfigs, selectRemitaConfig],
  (allConfigs, remitaConfig) =>
    allConfigs?.find((config) => config?.id === remitaConfig?.id) || null
);

export const selectRemitaCharge = createSelector(
  [paymentConfigSelector],
  (payment) => payment.remita?.schoolConfig?.charge || 0
);

export const selectRemitaChargeStatus = createSelector(
  [selectRemitaConfigSummary],
  (summary) => summary?.isChargeEnabled || false
);

export const selectRemitaConfigLoading = createSelector(
  [paymentConfigSelector],
  (payment) => payment.fetchingRemitaConfig
);

// Interswitch

export const selectInterswitchConfig = createSelector(
  [paymentConfigSelector],
  (payment) => payment.interSwitch
);

export const selectInterswitchConfigSummary = createSelector(
  [selectAllConfigs, selectInterswitchConfig],
  (allConfigs, interswitchConfig) =>
    allConfigs?.find((config) => config?.id === interswitchConfig?.id) || null
);

export const selectInterswitchCharge = createSelector(
  [paymentConfigSelector],
  (payment) => payment.interSwitch?.schoolConfig?.charge || 0
);

export const selectInterswitchChargeStatus = createSelector(
  [selectInterswitchConfigSummary],
  (summary) => summary?.isChargeEnabled || false
);

export const selectInterswitchConfigLoading = createSelector(
  [paymentConfigSelector],
  (payment) => payment.fetchingInterswitchConfig
);

// CRUD ops

export const selectImportAccountsLoading = createSelector(
  [paymentConfigSelector],
  (payment) => payment.importingBankAccounts
);

export const selectDeleteConfigLoading = createSelector(
  [paymentConfigSelector],
  (payment) => payment.deletingConfig
);

export const selectUpdateConfigLoading = createSelector(
  [paymentConfigSelector],
  (payment) => payment.updatingConfig
);

// Charge selectors

export const selectTotalCharge = createSelector(
  [selectRemitaCharge, selectPaystackCharge, selectInterswitchCharge],
  (remitaCharge, paystackCharge, interswitchCharge) =>
    remitaCharge + paystackCharge + interswitchCharge
);

export const selectIsPlatformChargeEnabled = createSelector(
  [selectInstitution],
  (institutionInfo) => institutionInfo?.platformChargeEnabled || false
);

// Paystack
export const selectNabrollConfig = createSelector(
  [paymentConfigSelector],
  (payment) => payment.nabroll
);

export const selectNabrollConfigSummary = createSelector(
  [selectAllConfigs, selectNabrollConfig],
  (allConfigs, nabrollConfig) =>
    allConfigs?.find((config) => config?.id === nabrollConfig?.id) || null
);

export const selectNabrollConfigLoading = createSelector(
  [paymentConfigSelector],
  (payment) => payment.fetchingNabrollConfig
);
